import React, { useState } from "react";
import DetailBlock from "../../common/DetailBlock";
import LabelInput from "../../common/LabelInput";
import Body from "../../components/Body";
import { BiMoney } from "react-icons/bi";
import { FaMoneyCheckAlt } from "react-icons/fa";
import config from "../../config/config";
import colors from "../../config/colors";
import { cloneDeep, sum } from "lodash";
import numberFormat from "../../common/numberFormat";
import AppButton from "../../common/AppButton";
import { useParams } from "react-router-dom";
import api from "../../config/api";
import removeCommas from "../../common/removeCommas";
import numberOnly from "../../common/numberOnly";
import addPrecision from "../../common/addPrecision";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";

const formInit = {
  date: new Date(),
  amount: "",
  chequeNumber: "",
};
export default function ReceiveContractPayment({
  onSuccess,
  invoice,
  payments,
}) {
  const size = config.iconSize;
  const params = useParams();
  const [disabled, setDisabled] = useState(false);
  const [form, setForm] = useState(cloneDeep(formInit));
  const queryClient = useQueryClient();

  const handleChange = ({ currentTarget }) => {
    const name = currentTarget.name;
    const value = currentTarget.value;
    if (name === "price") {
      if (Number(removeCommas(value)) > balance) {
        return false;
      }
    }

    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (event) => {
    setDisabled(true);
    event.preventDefault();
    const res = await api.post("jobPayments", {
      ...form,
      contractInvoice: invoice._id,
      contract: invoice.contract._id,
      organization: invoice.contract.organization._id,
    });
    if (!res.ok) {
      setDisabled(false);
      return toast.error(res.originalError.message);
    }
    queryClient.invalidateQueries(["jobPayments"]);
    setDisabled(false);
    toast.success("Payment has been succesfully received.");
    onSuccess(res.data);
  };

  const balance =
    invoice.price - sum(payments?.map((i) => Number(removeCommas(i.amount))));

  return (
    <Body
      title="Receive Payment"
      bodyStyle={{ padding: 30 }}
      contentStyle={{ minHeight: 450 }}
    >
      <form onSubmit={handleSubmit}>
        <DetailBlock style={{ width: 600, boxShadow: "none" }}>
          <div
            className="d-flex"
            style={{
              alignItems: "flex-end",
              gap: "20px 40px",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <LabelInput
              onChange={handleChange}
              name="date"
              label="Date"
              datePicker
              value={form.date}
              required
            />
            <LabelInput
              leftIcon={<BiMoney size={size} color={colors.silver} />}
              name="amount"
              onChange={handleChange}
              placeholder={balance}
              value={numberFormat(form.amount)}
              required
              type="text"
            />

            <LabelInput
              leftIcon={<FaMoneyCheckAlt size={size} color={colors.silver} />}
              name="chequeNumber"
              onChange={handleChange}
              placeholder={"Cheque Number"}
              value={numberOnly(form.chequeNumber)}
              type="text"
            />
          </div>
        </DetailBlock>

        <div className="d-flex">
          <AppButton
            disabled={disabled}
            text="Receive"
            className="btn-primary"
            style={{ margin: "0px 0px" }}
          />
        </div>
      </form>
    </Body>
  );
}
